import React from 'react';
import { Helmet } from 'react-helmet';

// const FSRBanner = lazy(() => import('./components/FSRBanner'));
// const FSRWorkflow = lazy(() => import('./components/FSRWorkflow'));
// const FSRCapabilities = lazy(() => import('./components/FSRCapabilities'));
// const CTACard = lazy(() => import('../Landing/components/CTACard'));
// const FSRSuccessStory = lazy(() => import('./components/FSRSuccessStory'));
// const FSRHighlights = lazy(() => import('./components/FSRHighlights'));
// const FSRMarginImpact = lazy(() => import('./components/FSRMarginImpact'));
import FSBanner from './components/FSBanner';
import FSRWorkflow from './components/ArchiveWorkflow';
import FSCapabilities from './components/FSCapabilities';
import CTACard from '../Landing/components/CTACard';
import FSRSuccessStory from './components/ArchiveSuccessStory';
import FSRMarginImpact from './components/ArchiveMarginImpact';
import FSRHighlights from './components/ArchiveHighlights';
import FSRCapabilities from './components/ArchiveCapabilities';

type Props = {
  className?: string;
};

const FSRUseCase: React.FC<Props> = ({ className }) => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Built for Full Service Restaurants | TableTab</title>
        <meta name="robots" content="index, follow" />
        <meta
          name="description"
          content="TableTab mobile order and payment software for full service restaurants simplifies front-of-house operations, increases sales and profits, protects staff, and improves the dine-in guest experience."
        />
        <link rel="canonical" href="https://tabletab.io/use-cases/fsr/" />
      </Helmet>
      <FSBanner />
      {/*<FSCapabilities />*/}

      <FSRHighlights className={'mt-10 md:mt-14 lg:mt-16 xl:mt-20'} />
      <FSRWorkflow className={'mt-10 lg:py-32 xl:py-48 2xl:py-60'} />
      <FSRMarginImpact className={'py-10  md:mt-10 '} />
      <FSRCapabilities
        className={'py-10 mt-10 py-20 md:mt-20 pb-32 md:py-16 bg-gray-50'}
        fullscreen={true}
        color={'bg-gray-50'}
      />
      <FSRSuccessStory className={'md:mt-20 mb-32 mt-20'} />
      <div
        className={'bg-gray-100  relative'}
        style={{ marginLeft: '-50vw', marginRight: '-50vw' }}
      >
        <CTACard
          className={'md:pt-40 pt-24'}
          style={{ marginLeft: '50vw', marginRight: '50vw' }}
          // description={'Drop us your email, and we will send you how Cassava powered half of all transactions through TableTab.'}
        />
      </div>
    </>
  );
};

export default FSRUseCase;
